var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.trendShow)?_c('list',{ref:"list",attrs:{"row-key":"UserId","unit":"车间调拨单","page":_vm.page,"show-query":true,"get-data-func":_vm.api.list,"urlHash":"business/stock/outsourcingallocation"}},[_c('template',{slot:"toolbar-right"},[_vm._t("toolbar-right")],2),_c('template',{slot:"table"},[_vm._t("column")],2)],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }